import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { LargeSwitch } from 'components/ui/LargeSwitch'
import { EmailTypes } from 'enum'
import { Notification } from 'models/course.model'
import { determineGrammaticalGender } from 'helpers'
import InputLabel from '../../../field/input-label/InputLabel'
import { useForm } from '../../context'

interface Props {
  disabled?: boolean
}

const ReminderAutomated: React.FC<Props> = ({ disabled }) => {
  const { t } = useTranslation()
  const { values, setFieldValue } = useForm()

  const defaultValues = useMemo(() => {
    const app = t('commons.navBar.title')
    const context = determineGrammaticalGender(app)
    const options = { app, context }
    return {
      emailSubject: t(
        'administration.courses.new.form.notifications.reminder.default.subject',
        options
      ),
      emailBody: t(
        'administration.courses.new.form.notifications.reminder.default.body',
        options
      ),
    }
  }, [t])

  const value = values.reminderNoStartCourseNotification

  const onChange = (newValue: Partial<Notification>) => {
    setFieldValue('reminderNoStartCourseNotification', {
      active: false,
      emailType: EmailTypes.reminderNoStartCourse,
      ...defaultValues,
      ...value,
      ...newValue,
    })
  }

  return (
    <div className="d-flex align-items-center">
      <InputLabel
        className={classNames('mb-0 flex-fill')}
        label={
          <>
            {t('administration.courses.new.form.notifications.reminder.label')}
          </>
        }
      />
      <LargeSwitch
        checked={value?.active}
        disabled={disabled}
        checkedChildren={t('administration.courses.new.form.yes')}
        unCheckedChildren={t('administration.courses.new.form.no')}
        onChange={(checked) => onChange({ active: checked })}
      />
    </div>
  )
}

export default ReminderAutomated
